// extracted by mini-css-extract-plugin
module.exports = {"container":"e_3A","tab":"e_4A","active":"e_5A","movingBg":"e_6A"};